import { createApp } from 'vue';
import App from './App.vue';
import router from './router'; // Import the router instance
import vuetify from './plugins/vuetify';
import i18n from './i18n';

const app = createApp(App);

app.use(router);
app.use(vuetify);
app.use(i18n);

app.mount('#app');
